import { Box, CircularProgress } from "@mui/material";
import React from "react";

function Loader({ wrapContent, size }) {
  return (
    <Box
      height={wrapContent ? "auto" : "100%"}
      display="flex"
      alignItems="center"
      justifyContent="center"
      py={2}
    >
      <CircularProgress size={size || 36} />
    </Box>
  );
}

export default Loader;
